import React, { Component } from "react";
import { Row, Col, Button, Modal, Container, Form } from "react-bootstrap";
import Switch from "react-switch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./EditHelpline.css";

class EditHelpline extends Component {
  constructor(props) {
    super(props);
    this.state = {
        sprtNo: this.props.ItemList ? this.props.ItemList.sprtNo : null,
        sprtEmail: this.props.ItemList ? this.props.ItemList.sprtEmail : null,
        role: this.props.ItemList ? this.props.ItemList.role : null,
        isActive: this.props.ItemList ? this.props.ItemList.isActive : true,
        id: this.props.ItemList ? this.props.ItemList.id : null,
    };
    this.selectCategry = this.selectCategry.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
        ...this.state,
        sprtNo: nextProps.ItemList && nextProps.ItemList.sprtNo,
        sprtEmail: nextProps.ItemList && nextProps.ItemList.sprtEmail,
        role: nextProps.ItemList && nextProps.ItemList.role,
        isActive: nextProps.ItemList && nextProps.ItemList.isActive,
        id: nextProps.ItemList && nextProps.ItemList.id,
    });
  }
  onChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    if (name == "sprtNo") {
      this.setState({
        ...this.state, sprtNo: value
      });
    } else if (name == "sprtEmail") {
      this.setState({
         ...this.state, sprtEmail: value 
      });
    }
  
  };

  selectCategry = e => {
    this.setState({...this.state, role: e.target.value  });
  };

  handleChange=()=>{
    this.setState({
      ...this.state,
      isActive:!this.state.isActive
    });
  }

  submit = () => {
    const {sprtNo, sprtEmail, role, isActive, id } = this.state;
    let data={sprtNo:sprtNo, sprtEmail:sprtEmail, role:role, isActive:isActive, id:id};
    let regexemail = /^\S+@\S+\.\S+$/;
    let regexcode = /^[7-9][0-9]{9}$/;

    if (
      sprtNo === "" ||
      sprtEmail === "" ||
      role === "Select Role"
    ) {
      toast.error("Please fill out this field", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    } else if (!regexemail.test(sprtEmail)) {
      toast.error("Enter a valid email", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    }  else if (!regexcode.test(sprtNo)) {
      toast.error("Enter a valid mobile number", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    } else {
      this.props.EditHelpline(data);
      this.props.closeEditModel();
      this.props.resetPage();
    }
  };
  
  render() {
    const { sprtNo, sprtEmail, role, isActive,id } = this.state;
    return (
      <div>
        <Modal
          show={this.props.showEditModel}
          onHide={this.props.closeEditModel}
          animation={false}
          size="md"
          backdrop="static"
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>Helpline</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
            <Form>
                <Row>
                  <Col lg={6} sm={12} xs={12}>

                    <Form.Group controlId="sprtNo">
                      <Form.Label> Support Number </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="sprtNo"
                        value={sprtNo}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group controlId="sprtEmail">
                      <Form.Label> Support Email</Form.Label>
                      <Form.Control
                        type="text"
                        name="sprtEmail"
                        autoComplete="off"
                        value={sprtEmail}
                        onChange={this.onChange}
                      />
                    </Form.Group>

                  </Col>
                </Row>
                <Row>
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group controlId="role">
                      <Form.Label> Role</Form.Label>
                      <div style={{ width: "100%" }}>
                        <select style={{ width: "100%" }}
                          onChange={this.selectCategry}
                          class="form-control"
                          className="helplineSelect"
                          id="role"
                          value={role}
                        >
                          <option value="select" defaultValue>
                            Select Role
                      </option>
                          <option value="Chemist">Chemist</option>
                          <option value="Patient">Patient</option>
                          <option value="Distributor">Distributor</option>
                          <option value="Licensee">Licensee</option>
                        </select>
                      </div>
                    </Form.Group>
                  </Col>

                  <Col lg={6} sm={12} xs={12}>
                    <label style={{ display: "flex", marginTop: "0px" }}>
                      <Form.Group controlId="isActive">
                        <Form.Label>Active</Form.Label>
                        <div style={{ marginTop: "0px", marginLeft: "10px" }}>
                          <Switch
                            onChange={this.handleChange}
                            onColor="#20a8d8"
                            checked={isActive}
                          />
                        </div>
                      </Form.Group>
                    </label>
                  </Col>
                </Row>
              </Form>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
            <Button type="submit" onClick={this.submit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default EditHelpline;
